var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105",
    transform: "translate(-1357 -303)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4828",
    "data-name": "Rectangle 4828",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(1357 303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "zoom-in_1_",
    "data-name": "zoom-in (1)",
    transform: "translate(1363.911 309.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M20.707,18.406l-4.365-4.365A8.715,8.715,0,0,0,17.92,8.963a8.8,8.8,0,0,0-.707-3.481A8.775,8.775,0,0,0,12.441.709a8.93,8.93,0,0,0-6.962,0A8.774,8.774,0,0,0,.706,5.482a8.929,8.929,0,0,0,0,6.962,8.774,8.774,0,0,0,4.773,4.773,8.8,8.8,0,0,0,3.481.706,8.717,8.717,0,0,0,5.078-1.578L18.4,20.7a1.512,1.512,0,0,0,1.145.484,1.629,1.629,0,0,0,1.158-2.774Zm-7.719-5.416A5.491,5.491,0,0,1,8.96,14.665a5.491,5.491,0,0,1-4.028-1.674A5.49,5.49,0,0,1,3.258,8.963,5.491,5.491,0,0,1,4.932,4.935,5.49,5.49,0,0,1,8.96,3.261a5.492,5.492,0,0,1,4.028,1.674,5.49,5.49,0,0,1,1.674,4.028A5.491,5.491,0,0,1,12.988,12.991Z",
    transform: "translate(0 -0.003)",
    fill: "#176eb5",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M117.384,112.9h-2.851v-2.851a.413.413,0,0,0-.407-.407h-.815a.413.413,0,0,0-.407.407V112.9h-2.851a.413.413,0,0,0-.407.407v.814a.413.413,0,0,0,.407.407H112.9v2.851a.413.413,0,0,0,.407.407h.814a.413.413,0,0,0,.407-.407v-2.851h2.851a.412.412,0,0,0,.407-.407V113.3a.412.412,0,0,0-.407-.407Z",
    transform: "translate(-104.758 -104.752)",
    fill: "#176eb5",
    stroke: "#176eb5",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomin);
export default __webpack_public_path__ + "static/media/zoomin.d5abdb94ce3685c2c90578002f2f04c5.svg";
export { ForwardRef as ReactComponent };